/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IMedicationDetails } from 'app/shared/model/medication-details.model';
import { IMedicationScheduleDetails } from 'app/shared/model/medication-schedule-details.model';

export interface IMedicationMedicines {
  id?: string;
  tmDate?: number | null;
  tmStart?: number | null;
  tmEnd?: number | null;
  status?: boolean | null;
  active?: boolean;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  glucoUser?: IGlucoUser;
  medicine?: IMedicationDetails;
  scheduleDetail?: IMedicationScheduleDetails;
}

export const defaultValue: Readonly<IMedicationMedicines> = {
  status: false,
  active: false,
};
